// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
        ion-content {
          --background: transparent;
        }
  
        .square {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          border-radius: 16px;
          width: 200px;
          height: 200px;
          border: 6px solid white;
          box-shadow: 0 0 0 4000px rgba(0, 0, 0, 0.3);
        }
  
        .zoom-ratio-wrapper {
          position: absolute;
          left: 50%;
          bottom: 16px;
          transform: translateX(-50%);
          width: 50%;
        }
      `, "",{"version":3,"sources":["webpack://./src/app/components/barcode-scanning-modal.component.ts"],"names":[],"mappings":";QACQ;UACE,yBAAyB;QAC3B;;QAEA;UACE,kBAAkB;UAClB,SAAS;UACT,QAAQ;UACR,gCAAgC;UAChC,mBAAmB;UACnB,YAAY;UACZ,aAAa;UACb,uBAAuB;UACvB,2CAA2C;QAC7C;;QAEA;UACE,kBAAkB;UAClB,SAAS;UACT,YAAY;UACZ,2BAA2B;UAC3B,UAAU;QACZ","sourcesContent":["\n        ion-content {\n          --background: transparent;\n        }\n  \n        .square {\n          position: absolute;\n          left: 50%;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          border-radius: 16px;\n          width: 200px;\n          height: 200px;\n          border: 6px solid white;\n          box-shadow: 0 0 0 4000px rgba(0, 0, 0, 0.3);\n        }\n  \n        .zoom-ratio-wrapper {\n          position: absolute;\n          left: 50%;\n          bottom: 16px;\n          transform: translateX(-50%);\n          width: 50%;\n        }\n      "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
